import { CdkDrag } from '@angular/cdk/drag-drop';

/**
 * Keeps track of every drop list in the form activity editor (the main entity
 * list plus every Row / Group layout list) so that data entities can be
 * dragged between any of them.
 *
 * The CDK connects lists by id, and the Row / Group editors can be repeated
 * many times on one form, so each list registers a unique id here and connects
 * to all the others through the shared (same reference) array.
 */
export const LAYOUT_DROP_LISTS: string[] = [];

let nextId = 0;

export function registerLayoutDropList(prefix: string): string {
  const id = `${prefix}-${nextId++}`;
  LAYOUT_DROP_LISTS.push(id);
  return id;
}

export function unregisterLayoutDropList(id: string) {
  const index = LAYOUT_DROP_LISTS.indexOf(id);
  if (index > -1) {
    LAYOUT_DROP_LISTS.splice(index, 1);
  }
}

/**
 * Rows and Groups only hold data entities. A layout item (Row, Group, Table)
 * has no `entity`, so it must not be dropped into another layout.
 */
export function canEnterEntityLayout(drag: CdkDrag): boolean {
  return !!drag?.data?.entity;
}
